import axiosInstance from '@/utils/httpUtil'

import { setting } from '@/setting'

const authBaseUrl = setting.authBaseUrl
const adminBaseUrl = setting.adminBaseUrl
export const adminApi = {

    login: (account, password) => {
        return axiosInstance.post(`${authBaseUrl}/login`, {
          account: account,
          password: password,
        })
    },

    downloadIntershipNewsBatchCreateTemplateExcel: () => { 
        return axiosInstance.get(`${adminBaseUrl}/batch/intershipNews/templateExcel`, {
          responseType: 'blob', // 指定回傳的資料類型為二進制
        })
    },

    downloadIntershipNewsBatchCreateErrorLogExcel: () => { 
        return axiosInstance.get(`${adminBaseUrl}/batch/intershipNews/errorLog`, {
            responseType: 'blob', // 指定回傳的資料類型為二進制
        })
    },

    uploadIntershipNewsBatchCreateExcel: (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return axiosInstance.post(`${adminBaseUrl}/batch/intershipNews`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    getIntershipNews: (page, pageSize) => {
        return axiosInstance.get(`${adminBaseUrl}/intershipNews`, {
          params: {
            page: page,
            pageSize: pageSize
          }
        })
      },

    getIntershipNewsDetail: (newsId) => {
        return axiosInstance.get(`${adminBaseUrl}/intershipNews/${newsId}`)
    },

    updateIntershipNews: (newsId, formData) => {
        return axiosInstance.put(`${adminBaseUrl}/intershipNews/${newsId}`, formData, {
          headers: {
            'Content-Type': 'application/json' // 明确指定JSON格式
          }
        })
      },
    
    createIntershipNews: (formData) => {
        return axiosInstance.post(`${adminBaseUrl}/intershipNews`, formData, {
            headers: {
            'Content-Type': 'application/json'
            }
        })
    },
    deleteIntershipNews: (newsId) => {
        return axiosInstance.delete(`${adminBaseUrl}/intershipNews/${newsId}`)
      }
}